import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideoClip: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"video-clip, film, movie"} maskId="square-filled-radius-0-stroke-1-IconVideoClip"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM4 4V7.25H7V4H4ZM17 4V7.25H20V4H17ZM20 8.25H17V11.5H20V8.25ZM20 12.5H17V16.2222H20V12.5ZM20 17.2222H17V20H20V17.2222ZM16 12.5V11.5H8V12.5H16ZM7 20V16.75H4V20H7ZM4 15.75H7V12.5H4V15.75ZM4 11.5H7V8.25H4V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVideoClip;
